/**
 * Tooltip
 *
 * View that deals with creating the offer tooltip popups
 *
 * @return {view}
 */

OT.createNS('OT.Redesign.Views.Modals.Tooltip');

OT.Redesign.Views.Modals.Tooltip = Backbone.ViewManager.BaseView.extend({

    el: '#tooltip',

    template: 'Redesign/Modals/_OffersTooltip',

    beforeRender: function() {
        return true;
    },

    onRender: function () {
        this.$el.show();
        this.position();

        return this;
    },

    position: function () {
        var tooltipModal = this.$el.find('.menu-container'),
            top = this.$target.offset().top - tooltipModal.height() - 8,
            left = this.$target.offset().left;

        this.$el.css({
            'margin-top': top,
            'margin-left': left
        });
    }

});